module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel01_770_280_ko-93e751191c2003635c7626d730b39e9f.jpg";